import type { Icon } from "@phosphor-icons/react";
import clsx from "clsx";

export const GameOption: React.FC<{
  icon: Icon;
  onClick: () => void;
  className?: string;
}> = ({ icon: Icon, onClick, className }) => {
  return (
    <button
      className={clsx("btn btn-square btn-ghost", className)}
      onClick={onClick}
      onMouseDown={(event) => {
        event.preventDefault();
      }}
    >
      <Icon className="size-8" />
    </button>
  );
};
